export const TOP_PAGE_SECTIONS = {
  RANKING: {
    title: '募集ランキング',
    description: '今最も注目されている募集情報をランキングでチェック！',
  },
  DEADLINE: {
    title: '締切間近の募集',
    description: '締切まで残りわずか！見逃せない募集情報をピックアップ',
  },
  RECOMMEND: {
    title: 'あなたにおすすめの募集',
    description: 'あなたの志望やフォローに基づいた募集情報をおすすめします',
  },
  BROWSING_HISTORY_RECOMMEND: {
    title: '最近見た募集からのおすすめ',
    description:
      '最近ご覧いただいた募集をもとに、まだエントリーされていない募集をお届けします',
  },
  QUICK_ENTRY: {
    title: 'すぐに応募できる募集',
    description:
      'エントリーフォームの質問入力なしで完了。プロフィール情報だけで、選考への一歩を踏み出せます',
  },
  RECENT: {
    title: '新着の募集',
    description: '最新の募集情報をいち早くチェック！',
  },
  GSSKT_EVENT: {
    title: '外資就活主催イベント',
    description: '外資就活ドットコムが主催する特別なイベント情報をお届けします',
  },
  RECOMMENDED_COMPANIES: {
    title: 'おすすめの企業',
    description: '注目の企業情報をチェック！企業研究にお役立てください',
  },
  FOLLOW_RANKING: {
    title: 'フォロー企業ランキング',
    description:
      '今、最も多くの学生にフォローされた人気企業をランキング形式でご紹介',
  },
  NEW_COLUMN: {
    title: '新着コラム',
    description: '最新のコラムをチェック！就活のヒントが見つかるかも',
  },
  SPECIAL_CONTENT: {
    title: 'スペシャルコンテンツ',
    description: '外資就活ドットコムにしかない特別なコンテンツをお届けします',
  },
} as const;

export const CAROUSEL_CONFIG = {
  SKELETON_COUNT: 5,
  RECRUITMENT_LIMIT: 10,
  RECRUITMENT_RANKING_LIMIT: 20,
  BROWSING_HISTORY_RECOMMEND_LIMIT: 20,
  COMPANY_LIMIT: 10,
  INTERESTS_LIMIT: 10,
  PC: {
    COMPANY_CARD_WIDTH: 369,
    GAP: 16,
  },
  SP: {
    COMPANY_CARD_WIDTH: 369,
    GAP: 16,
  },
  CARD_HEIGHT: {
    COMPANY: 150,
  },
} as const;

export const SPECIAL_CONTENTS = [
  {
    src: '/next-image/top/specialContent/banner_report_analytics.png',
    alt: 'AI選考対策',
    href: '/report_analytics/search',
  },
  {
    src: '/next-image/top/specialContent/banner_community.png',
    alt: '外資就活コミュニティ',
    href: '/questions',
  },
  {
    src: '/next-image/top/specialContent/banner_question.png',
    alt: '外資就活相談室',
    href: '/box/answers',
  },
  {
    src: '/next-image/top/specialContent/banner_engineer.png',
    alt: 'Software Engineer 就活',
    href: '/engineer',
  },
] as const;
